import { NgModule, ErrorHandler } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatRadioModule } from '@angular/material/radio';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatCardModule } from '@angular/material/card';
import { MatTableModule } from '@angular/material/table';
import { MatGridListModule } from '@angular/material/grid-list';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RootComponent } from './components/root/root.component';
import { LoginComponent } from './components/login/login.component';
import { LoginSecondFactorComponent } from './components/loginSecondFactor/loginSecondFactor.component';
import { PasswordResetPINComponent } from './components/passwordResetPin/passwordResetPin.component';
import { HalfAuthGuard } from './services/authGuard/authGuard.service';

import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TeCommonUiModule } from '@tecommon/ui/ui.module';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { LoginUserInfoService } from './services/authGuard/login.userInfo.service';
import { CurrentUserInfoService } from '../Main/services/userInfo/current.userInfo.service';
import { UserInfoService } from '../Main/services/userInfo/userInfo.service';
import { GlobalErrorHandlerService } from './services/errorHandler/global-error-handler.service';
import { SessionCheck, SessionTimeoutDialog } from './services/sessionCheck/sessionCheck.service';
import { UserIdMismatchError } from './components/userIdMismatchError/userIdMismatchError.component'
import { SDContactsComponent } from './components/sdContacts/sdContacts.component'

// AoT requires an exported function for factories
export function httpLoaderFactory(http: HttpClient)
{
    return new TranslateHttpLoader(http, '/Common/i18n/Login/', '.json');  //base href of /Login is throwing this off.. 
}

@NgModule({
    bootstrap: [RootComponent],
    declarations: [
        RootComponent,
        LoginComponent,
        LoginSecondFactorComponent,
        PasswordResetPINComponent,
        SessionTimeoutDialog,
        UserIdMismatchError,
        SDContactsComponent
    ],
    providers: [
        HalfAuthGuard,
        LoginUserInfoService, UserInfoService,
        CurrentUserInfoService,
        GlobalErrorHandlerService,
        { provide: ErrorHandler, useClass: GlobalErrorHandlerService },
        SessionCheck
    ],
    imports: [
        BrowserModule,
        CommonModule,
        HttpClientModule,
        FormsModule,
        ReactiveFormsModule,
        BrowserAnimationsModule,
        MatButtonModule,
        MatProgressBarModule,
        MatProgressSpinnerModule,
        MatFormFieldModule,
        MatSelectModule,
        MatInputModule,
        MatExpansionModule,
        MatIconModule,
        MatCardModule,
        MatMenuModule,
        MatRadioModule,
        TeCommonUiModule, MatTableModule, MatGridListModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: httpLoaderFactory,
                deps: [HttpClient]
            }
        }),
        RouterModule.forRoot([
            { path: 'Entry', component: LoginComponent },
            { path: 'SDContacts', component: SDContactsComponent },
            { path: 'LoginSecondFactor', component: LoginSecondFactorComponent, canActivate: [HalfAuthGuard] },
            { path: 'PasswordResetPIN', component: PasswordResetPINComponent, canActivate: [HalfAuthGuard] },  // Half Auth Guard!
            { path: 'UserIdMismatchError/:errorType', component: UserIdMismatchError },
            { path: '**', redirectTo: 'Entry' }
        ])
    ]
})
export class SSPLoginModule
{
}
